/* Compiled from the nc-*-v4 sub-snippets (DOM-diet refactor 2026-08-06).
   Source of truth stays in each snippet's {% style %}/<script> block —
   those render only when isAssetLoaded is falsy (i.e. outside nc-body-v4).
   After editing a snippet's CSS/JS, re-sync this file.

   AOV variant swap 2026-08-07: each snippet's DOMContentLoaded callback is
   registered in ncBodyInits and re-run on the `nc:body-reinit` event —
   aov-pdp-v3.js dispatches it after replacing the body container's innerHTML
   on a flavor/dose swap (the replace kills every listener inside; the
   swapped-in HTML is raw server markup, so sliders re-slick cleanly). Keep
   each callback's inner code byte-identical to its snippet source — only the
   wrapper differs. The YouTube popup init (ex nc-body-v4.liquid
   {% javascript %} block) lives here too for the same reason: its markup is
   rendered by nc-content-v4 INSIDE the swapped container. */
(function () {
  var ncBodyInits = [];
  function ncBodyRegister(fn) { ncBodyInits.push(fn); }
  function ncBodyRunInits() { ncBodyInits.forEach(function (fn) { try { fn(); } catch (e) { console.error('[nc-body-v4 init]', e); } }); }
  document.addEventListener('DOMContentLoaded', ncBodyRunInits);
  document.addEventListener('nc:body-reinit', ncBodyRunInits);

/* ==== source: snippets/nc-reviews-v4.liquid ==== */

  ncBodyRegister(function() {
  console.log('reviews init');
    const settings = {
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 4,
      responsive: [
       {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            centerMode: true,
            centerPadding: "40px",
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: "40px",
            infinite: true
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "40px",
            infinite: true
          }
        }
      ]
    };

    let reviewsTestimonial;


    if ($('.slick-slider-reviews')) {
      reviewsTestimonial = $('.slick-slider-reviews').slick(settings);
    }

    const prevButton = document.querySelector('.nc-reviews-v4__carouselNav svg:first-child');
    const nextButton = document.querySelector('.nc-reviews-v4__carouselNav svg:last-child');

    if (reviewsTestimonial && prevButton) {
      prevButton.addEventListener('click', () => {
        reviewsTestimonial.slick('slickPrev');
      });
    }

    if (reviewsTestimonial && nextButton) {
      nextButton.addEventListener('click', () => {
        reviewsTestimonial.slick('slickNext');
      });
    }

  });

/* ==== source: snippets/nc-ingredients-v4.liquid ==== */

      ncBodyRegister(function() {
        const button = document.querySelector(".nc-ingredients-v4__button");
        const container = document.querySelector(".nc-ingredients-v4--3col");

        if (button && container) {
          button.addEventListener("click", function() {
            container.classList.add("is-expanded");
          });
        }
      });

/* ==== source: snippets/nc-content-v4.liquid ==== */

  ncBodyRegister(function () {
    const sections = document.querySelectorAll(".nc-content-v4--auto-video-play");

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const section = entry.target;
          const video = section.querySelector("video");

          if (!video) return;

          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, {
        threshold: 0.5
      });

      sections.forEach(section => {
        observer.observe(section);
      });
    }
  });

/* ==== source: snippets/nc-testimonials-slider-v4.liquid ==== */

    ncBodyRegister(function() {
      const settings = {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 5,
        responsive: [
         {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              infinite: true,
              variableWidth: true,
              centerPadding: "70px"
            }
          }
        ]
      };

      let sliderTestimonial;

      if ($('.nc-testimonials-slider-v4__slider')) {
        sliderTestimonial = $('.nc-testimonials-slider-v4__slider').slick(settings);
      }

      const prevButton = document.querySelector('.nc-testimonials-slider-v4__sliderNavButton:first-child');
      const nextButton = document.querySelector('.nc-testimonials-slider-v4__sliderNavButton:last-child');

      if (sliderTestimonial && prevButton) {
        if (prevButton) {
          prevButton.addEventListener('click', () => {
            sliderTestimonial.slick('slickPrev');
          });
        }
        if(nextButton) {
          nextButton.addEventListener('click', () => {
            sliderTestimonial.slick('slickNext');
          });
        }
      }

  const testimonialItems = document.querySelectorAll('.nc-testimonials-slider-v4__item');

  testimonialItems.forEach(item => {
    const imageWrapper = item.querySelector('.nc-testimonials-slider-v4__itemImageWrapper');

    if (imageWrapper) {
      imageWrapper.addEventListener('click', function() {
        const youtubeId = item.getAttribute('data-youtube-id');

        if (youtubeId) {
          const iframe = item.querySelector('iframe');

          if (iframe) {
            const isPlaying = imageWrapper.classList.contains('nc-testimonials-slider-v4__itemImageWrapper--hide');

            if (isPlaying) {
              // imageWrapper.classList.remove('nc-testimonials-slider-v4__itemImageWrapper--hide');

              // const currentSrc = iframe.getAttribute('src');
              // iframe.setAttribute('src', '');
              // setTimeout(() => {
                // let newSrc = currentSrc.replace('&autoplay=1', '').replace('?autoplay=1&', '?').replace('?autoplay=1', '');
                // iframe.setAttribute('src', newSrc);
              // }, 10);
            } else {
              imageWrapper.classList.add('nc-testimonials-slider-v4__itemImageWrapper--hide');
              imageWrapper.classList.add('nc-testimonials-slider-v4__itemImageWrapper--none');

              let currentSrc = iframe.getAttribute('src');
              if (currentSrc && currentSrc.indexOf('autoplay=1') === -1) {
                const separator = currentSrc.indexOf('?') !== -1 ? '&' : '?';
                iframe.setAttribute('src', `${currentSrc}${separator}autoplay=1`);
              }
            }
          }
        } else if (item.classList.contains('nc-testimonials-slider-v4__item--video')) {
          const video = item.querySelector('.nc-testimonials-slider-v4__itemVideo');

          if (video && video.tagName === 'VIDEO') {
            if (video.paused) {
              video.play();
              imageWrapper.classList.add('nc-testimonials-slider-v4__itemImageWrapper--hide');
            } else {
              video.pause();
              imageWrapper.classList.remove('nc-testimonials-slider-v4__itemImageWrapper--hide');
            }
          }
        }
      });
    }
  });
    });

/* ==== source: sections/nc-body-v4.liquid {% javascript %} (moved here 2026-08-07) ==== */

  ncBodyRegister(function() {
    const rootYoutubePopupContent = document.querySelector('.YoutubePopup-root-ncv4');
    const rootPlayerContent = document.querySelector('.YoutubePopup-root_player-ncv4');
    const rootOverlayContent = document.querySelector('.YoutubePopup-root_overlay-ncv4');
    const rootCloseContent = document.querySelector('.YoutubePopup-root_close-ncv4');
    const iframeContent = document.querySelector('.YoutubePopup-root_video-ncv4 iframe');
    const videoItemContent = document.querySelectorAll('.nc-content_video');

    const handleKeyDownContent = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
          closeYoutubePopupContent();
      }
    }

    const openYoutubePopupContent = (videoId) => {
      iframeContent.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      rootYoutubePopupContent.style.display = 'block';


      document.addEventListener('keydown', handleKeyDownContent);
    }

    const closeYoutubePopupContent = () => {
      iframeContent.src = '';
      rootYoutubePopupContent.style.display = 'none';

      document.removeEventListener('keydown', handleKeyDownContent);
    }

    if(videoItemContent) {
      [].slice.call(videoItemContent).forEach(el => {
        el.addEventListener('click', () => {
          const videoIdContent = el.getAttribute('data-youtube-id');
          openYoutubePopupContent(videoIdContent);
        });
      })
      };


    if (rootOverlayContent) {
      rootOverlayContent.addEventListener('click', closeYoutubePopupContent);
    }

    if (rootCloseContent) {
      rootCloseContent.addEventListener('click', closeYoutubePopupContent);
    }
  });

})();
